"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleaner = exports.markdown = void 0;
const pythia_libs_1 = require("@yandex-int/pythia-libs");
exports.markdown = (0, pythia_libs_1.factoryRenderer)(CONFIG.markdown);
exports.cleaner = (0, pythia_libs_1.Cleaner)(CONFIG.markdown);
